import { DocumentManagementTypes } from "../../utils/constants";
import ElectronicDams from "../AffectedDams/ElectronicDams";
import SenasaDams from "../AffectedDams/SenasaDams";
import CreditAuth from "../CreditAuth/CreditAuth";
import ThirdPartyAuth from "../ThirdPartyAuth/ThirdPartyAuth";

const {
  SENASA_RESTRICTION,
  ELECTRONIC_MANDATE,
  THIRD_PARTY_AUTH,
  CREDIT_AUTH,
} = DocumentManagementTypes;

function DocumentManagementBrowsingList(props) {
  const { activeMenu } = props;
  return (
    <>
      {(() => {
        switch (activeMenu) {
          case SENASA_RESTRICTION:
            return <SenasaDams />;
          case ELECTRONIC_MANDATE:
            return <ElectronicDams />;
          case THIRD_PARTY_AUTH:
            return <ThirdPartyAuth />;
          case CREDIT_AUTH:
            return <CreditAuth />;
        }
      })()}
    </>
  );
}

export default DocumentManagementBrowsingList;
